<script lang="ts" setup>
import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";
import type { DanishRussianArticle } from "@/types/article-formats/russian";

const props = defineProps<{
  article: DanishRussianArticle;
  isCollapsible: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <ArticleContent>
    <div class="article-content__header article-header" v-html="props.article.header"></div>

    <ArticleContentCollapser :is-collapsible="props.isCollapsible">
      <div
        class="article-content__body-container article-content__body-container--reading-lines d-flex flex-column flex-lg-row"
      >
        <div class="indentation-container flex-grow-1 flex-shrink-1">
          <ul class="article-content__list">
            <li v-for="(line, index) in props.article.lines" :key="index">
              <span v-html="line"></span>
            </li>
          </ul>
        </div>
      </div>
    </ArticleContentCollapser>
  </ArticleContent>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.article-content {
  &__header {
    align-items: baseline;
    white-space: pre-wrap;

    ::v-deep(.russian-serif),
    ::v-deep(.russian-serif-bold) {
      color: rgb(@theme-colors[@secondary][base]);
      font-size: 24px;
      font-weight: 600;
    }

    ::v-deep(.russian-serif-italic) {
      font-style: italic;
    }
  }

  &__body-container {
    ::v-deep(.russian-serif-bold) {
      font-weight: 700;
    }

    ::v-deep(.russian-serif-italic) {
      font-style: italic;
    }
  }

  &__list {
    margin-bottom: 0;
    padding-left: 15px;
  }
}
</style>
